import { OpaqueToken } from '@angular/core';
export var STORE_DEVTOOLS_CONFIG = new OpaqueToken('@ngrx/devtools Options');
export var INITIAL_OPTIONS = new OpaqueToken('@ngrx/devtools Initial Config');
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/~/@ngrx/store-devtools/src/config.js
// module id = CcDZ
// module chunks = 5